const intitialState = {
  isAuthenticated: false,
}

const user = (state = intitialState, { type, payload }) => {
  switch (type) {
  case 'LOAD_USER':
    return { isAuthenticated: true, data: payload }
  case 'UNLOAD_USER':
    return {
      isAuthenticated: false,
      data: null,
    }
  default:
    return state
  }
}

export default user
